import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { CriticalBoardResponse } from '@/types/fraudHub';

/**
 * Fetches the top 25 open Critical alerts PER TRANSACTION KIND (joined to
 * station/merchant for one-line context) for the Fraud Hub Critical Alerts
 * Board, plus `counts_by_kind` — the true open-Critical DB totals the tab
 * badges render.
 *
 * Auto-refreshes every 60 seconds — investigators rely on this surface
 * to be live; staleTime is 30 s so a manual nav back to the page during
 * the same minute serves cache without a refetch flicker.
 */
export function useFraudHubCriticalBoard(): UseQueryResult<
  CriticalBoardResponse,
  Error
> {
  return useQuery<CriticalBoardResponse, Error>({
    queryKey: ['fraud-hub', 'critical-board'],
    queryFn: async () => {
      const { data } = await api.get<CriticalBoardResponse>(
        '/fraud-hub/critical-board',
      );
      return data;
    },
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}
